module.exports = __webpack_public_path__ + "img/label.65134dc6.svg";